import moment from "moment";

const MongoToMoment = function convertMongodDBIDToMoment(mongoId) {
	/*
        Converts a date string to a moment.
    */

	const timestamp = mongoId.toString().substring(0, 8);
	const momentDate = moment(parseInt(timestamp, 16) * 1000);

	return momentDate;
};

export default MongoToMoment;
